import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ERateOurEstimationActions } from '../../constants/actionTypes/rateOurEstimation';
import { ERateValues, ERateScreen } from '../../types/redux/rateOurEstimation';

export const setRateOurComment = actionGenerator<ERateOurEstimationActions.SET_COMMENT, string>(
  ERateOurEstimationActions.SET_COMMENT,
);
export const setRateOurUserPrice = actionGenerator<ERateOurEstimationActions.SET_USER_PRICE, number>(
  ERateOurEstimationActions.SET_USER_PRICE,
);
export const setRateOurEstimationValue = actionGenerator<
  ERateOurEstimationActions.SET_RATE_OUR_ESTIMATION,
  ERateValues
>(ERateOurEstimationActions.SET_RATE_OUR_ESTIMATION);
export const setRateOurIsScoreFact = actionGenerator<ERateOurEstimationActions.SET_IS_SCORE_FACT, boolean>(
  ERateOurEstimationActions.SET_IS_SCORE_FACT,
);
export const toggleRateOurModal = actionGenerator<ERateOurEstimationActions.TOGGLE_MODAL, boolean>(
  ERateOurEstimationActions.TOGGLE_MODAL,
);
export const setRateOurEstimationScreen = actionGenerator<ERateOurEstimationActions.SET_SCREEN, ERateScreen>(
  ERateOurEstimationActions.SET_SCREEN,
);
export const toggleRateOurEstimationLoading = actionGenerator<ERateOurEstimationActions.TOGGLE_LOADING, boolean>(
  ERateOurEstimationActions.TOGGLE_LOADING,
);
export const toggleRateOurEstimationLoadingBlock = actionGenerator<
  ERateOurEstimationActions.TOGGLE_LOADING_BLOCK,
  boolean
>(ERateOurEstimationActions.TOGGLE_LOADING_BLOCK);

export type TSetRateOurCommentAction = ReturnType<typeof setRateOurComment>;
export type TSetRateOurUserPriceAction = ReturnType<typeof setRateOurUserPrice>;
export type TRetRateOurEstimationValueAction = ReturnType<typeof setRateOurEstimationValue>;
export type TSetRateOurIsScoreFactAction = ReturnType<typeof setRateOurIsScoreFact>;
export type TToggleRateOurModalAction = ReturnType<typeof toggleRateOurModal>;
export type TSetRateOurEstimationScreenAction = ReturnType<typeof setRateOurEstimationScreen>;
export type TToggleRateOurEstimationLoadingAction = ReturnType<typeof toggleRateOurEstimationLoading>;
export type TToggleRateOurEstimationLoadingBlockAction = ReturnType<typeof toggleRateOurEstimationLoadingBlock>;

export type TRateOurEstimationActions =
  | TSetRateOurCommentAction
  | TSetRateOurUserPriceAction
  | TRetRateOurEstimationValueAction
  | TSetRateOurIsScoreFactAction
  | TToggleRateOurModalAction
  | TSetRateOurEstimationScreenAction
  | TToggleRateOurEstimationLoadingAction
  | TToggleRateOurEstimationLoadingBlockAction;
